import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="beat-container max-w-3xl mx-auto">
      <div className="beat-card p-8 rounded-lg">
        <h1 className="text-3xl font-bold text-newspaper-900 mb-4">Privacy Policy</h1>
        <p className="text-newspaper-600 mb-6">Last updated: December 2, 2025</p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Overview</h2>
        <p className="text-newspaper-700 mb-4">
          This Privacy Policy explains how we collect, use, and protect your information when you use Beatpost, a
          public publishing platform. By using Beatpost, you agree to the practices described here.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Information We Collect</h2>
        <ul className="list-disc pl-6 text-newspaper-700 mb-4">
          <li>Account data: username, email, profile information you choose to provide.</li>
          <li>Content data: articles, comments, hashtags, ratings, and associated metadata.</li>
          <li>Usage data: device, browser, IP address, pages visited, and interactions.</li>
        </ul>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">How We Use Information</h2>
        <ul className="list-disc pl-6 text-newspaper-700 mb-4">
          <li>To operate and improve the platform and its features.</li>
          <li>To provide authentication, notifications, and account management.</li>
          <li>To maintain platform integrity, detect abuse, and enforce policies.</li>
        </ul>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Legal Basis</h2>
        <p className="text-newspaper-700 mb-4">
          We process data based on your consent, our legitimate interests in operating the service, and contractual
          necessity for providing requested features.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Sharing of Information</h2>
        <p className="text-newspaper-700 mb-4">
          Public content you publish may be visible to anyone. We may share limited data with service providers that
          help us deliver the platform (for example, hosting, email, storage). We do not sell your personal data.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Data Retention</h2>
        <p className="text-newspaper-700 mb-4">
          We retain information as long as needed to operate the platform, comply with legal obligations, and resolve
          disputes. You may delete your content or account; residual backups may persist for a limited time.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Security</h2>
        <p className="text-newspaper-700 mb-4">
          We use reasonable technical and organizational measures to protect data. No online service can guarantee
          absolute security.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Your Rights</h2>
        <ul className="list-disc pl-6 text-newspaper-700 mb-4">
          <li>Access and update your profile information.</li>
          <li>Delete your content or your account.</li>
          <li>Withdraw consent where applicable.</li>
        </ul>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Children</h2>
        <p className="text-newspaper-700 mb-4">Beatpost is not directed to children under 13. Do not register if you are under 13.</p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">International Transfers</h2>
        <p className="text-newspaper-700 mb-4">
          Your information may be processed in countries different from your own. By using Beatpost, you consent to
          such transfers subject to applicable safeguards.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Changes</h2>
        <p className="text-newspaper-700 mb-4">
          We may update this Privacy Policy. Material changes will be indicated by updating the “Last updated” date.
        </p>

        <h2 className="text-xl font-semibold text-newspaper-900 mb-2">Contact</h2>
        <p className="text-newspaper-700">
          Questions about privacy can be sent to our support email published on the Contact page.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

